import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRibbon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2 16V0h12v16h-2l-4-3-4 3z",
		clipRule: "evenodd"
	})
});
export default SvgRibbon;
